import API from "../../../services/api";
import { ValidateTokenParams, ValidateTokenResponse } from "../types/token";

enum Endpoints {
  IsTokenValid = "/is_token_valid"
}

const isValidateTokenRes = (maybeValidateTokenRes: any): maybeValidateTokenRes is ValidateTokenResponse => {
  return maybeValidateTokenRes && (
    typeof maybeValidateTokenRes?.token_is_valid === "boolean"
  )
}

const validateToken = ({token}: ValidateTokenParams) => {
  return new Promise<ValidateTokenResponse>(async (resolve, reject) => {
    API.post<ValidateTokenResponse, ValidateTokenParams>({
      endpoint: Endpoints.IsTokenValid,
      data: {
        token
      }
    })
    .then(res => {
      if(isValidateTokenRes(res.promise.data)) {
        resolve(res.promise.data);
      } else {
        reject(res);
      }
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  validateToken
};